export const numberValidate = (e) => {
    // console.log(e.key);
    const key = ['ArrowUp', 'ArrowDown', '-', '+', 'e', 'E']
    key.includes(e.key) && e.preventDefault()
}

export const limitLength = (e, num) => {
    (e.target.value.length >= num) && (e.target.value = e.target.value.slice(0,num))
}